import { app } from '../../../../app';

class ApprovalPoliciesService {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    getPoliciesForCompany(companyId) {
        const url = `app/rest/companies/${companyId}/approvalpolicies`;
        return this.$http.get(url).then(({data}) => data);
    }

    createNewPolicy(companyId) {
        const url = `app/rest/companies/${companyId}/approvalpolicies`;
        return this.$http.post(url).then(({data}) => data);
    }

    getPolicyDetails(policyId, companyId) {
        const url = `app/rest/companies/${companyId}/approvalpolicies/${policyId}`;
        return this.$http.get(url).then(({data}) => data); 
    }

    updatePolicy(policy, companyId) {
        const url = `app/rest/companies/${companyId}/approvalpolicies/${policy.id}`;
        return this.$http.put(url, policy).then(({data}) => data);
    }

    deletePolicy(policyId, companyId) {
        const url = `app/rest/companies/${companyId}/approvalpolicies/${policyId}`;
        return this.$http.delete(url).then(({data}) => data);   
    }

    applyPolicy(applicationId, policyId, companyId) {
        const url = `app/rest/companies/${companyId}/approvalpolicies/${policyId}/${applicationId}`;
        return this.$http.put(url).then(({data}) => data);
    }
}

app.service('ApprovalPoliciesService', ApprovalPoliciesService);



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/policies/approval-policies.service.js